import { Order } from "./tableColumnSorter";

export default class ArraySort {
  static byString<TModel>(
    getter: (modal: TModel) => string | undefined,
    order: Order,
  ) {
    return (a: TModel, b: TModel) => {
      const propA = getter(a);
      const propB = getter(b);
      return propA !== undefined && propB !== undefined
        ? order === "asc"
          ? propB.localeCompare(propA)
          : propA.localeCompare(propB)
        : 0;
    };
  }

  static byNumber<TModel>(getter: (model: TModel) => number, order: Order) {
    return (a: TModel, b: TModel) => {
      const propA = getter(a);
      const propB = getter(b);
      return order === "desc" ? propA - propB : propB - propA;
    };
  }
}
